const initialState = {
  isOpen: false
};

export default function xgReducer (state = initialState, action) {
  switch (action.type) {
    case 'TOGGLE_XG_AREA':
      return {
        ...state,
        isOpen: action.payload
      };
    default:
      return state;
  }
}
